import React from 'react'

function NoPage() {
  return (
    <div>Page not found</div>
  )
}

export default NoPage